import React, {useState} from "react";
import Chart from "react-apexcharts";
import {CHART_NODATA_CONSTANT, transmissionChartOptions,} from "../Constants";
import {Button, ConfigProvider, Table} from "antd";
import {SET_SINGLE_METER_VALUE, SET_VIEW_SINGLE_METER} from "../../../store/features/systemAnalysisSlice";
import {useDispatch} from "react-redux";
import { clientColumnSorter } from "../../../utils/tableClientSort";

export const TransmissionAnalysis = ({showTable = false, analysisData = {}}) => {
    return (
        <div className={`grid grid-cols-2 gap-4`}>
            <div className={`${showTable ? "" : "col-span-2"}`}>
                <TransmissionAnalysisChart analysisData={analysisData}/>
            </div>
            {showTable && (
                <div>
                    <TransmissionAnalysisTable analysisData={analysisData}/>
                </div>
            )}
        </div>
    );
};
const TransmissionAnalysisChart = ({analysisData = {}}) => {
    return (
        <Chart
            key={"TransmissionAnalysisContentChart"}
            // options={transmissionChartOptions?.options}
            options={{
                chart: transmissionChartOptions?.options?.chart,
                labels: analysisData?.chart?.labels ?? [],
                ...CHART_NODATA_CONSTANT,

            }}
            series={analysisData?.chart !== undefined ? analysisData?.chart?.series?.map((val) => {
                return {
                    ...val,
                    type: val?.type?.toLowerCase()
                }
            }) : []}
            type="line"
            height={500}
        />
    );
};
const TransmissionAnalysisTable = ({analysisData = {}}) => {
    const dispatch = useDispatch();
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 14,
            pageSize: 3,
            total: analysisData?.tabularDatas?.length ?? 0,
        },
    });

    return (
        <ConfigProvider
            theme={{
                token: {
                    borderRadius: 0,
                },
                components: {
                    Table: {
                        /* here is your component tokens */
                        headerBg: "#F5F5F5",
                        headerColor: "#2F5E8A",
                        headerSortActiveBg: "#F5F5F5",
                        headerSortHoverBg: "#F5F5F5",
                        fixedHeaderSortActiveBg: "#F5F5F5",
                    },
                },
            }}
        >
            <Table
                className="table-striped-rows"
                dataSource={analysisData?.tabularDatas ?? []}
                //   rowSelection={{ type: "checkbox", ...rowSelection }}
                columns={[
                    {
                        title: "Serial Number",
                        dataIndex: "serialNumber",
                        width: "30%",
                        // defaultSortOrder: "descend",
                        sorter: clientColumnSorter("serialNumber"),
                        render: (text) => {
                            return (
                                <>
                                    <Button
                                        onClick={() => {
                                            dispatch(SET_SINGLE_METER_VALUE(text));
                                            dispatch(SET_VIEW_SINGLE_METER(true));
                                        }}
                                    >
                                        <p className="text-dark-blue-100">{text}</p>
                                    </Button>
                                </>
                            );
                        },
                    },
                    {
                        title: "Online",
                        dataIndex: "onlineDayCount",
                        sorter: clientColumnSorter("onlineDayCount"),
                    },
                    {
                        title: "Offline",
                        dataIndex: "offlineDayCount",
                        sorter: clientColumnSorter("offlineDayCount"),
                    },
                    {
                        title: "3 Days > Offline",
                        dataIndex: "moreThan3DaysOffline",
                        sorter: clientColumnSorter("moreThan3DaysOffline"),
                    }
                ]}
                pagination={tableParams}
                // showSizeChanger={true}
            ></Table>
        </ConfigProvider>
    );
};
